module.exports = __webpack_public_path__ + "img/Occupation.0a33181f.jpg";